import { AGENDA_UI_PATH } from '../../constants'

import {
  endOfDayDateUtil,
  formatISODateUtil,
  getDayDateStrDateUtil,
  getObjectUtil,
  startOfDayDateUtil,
  subDaysDateUtil
  , rangeArrayUtil
} from 'packages/src'
import { createSelector } from 'reselect'

const getDateSelect = (state) => {
  const date = getObjectUtil(state, AGENDA_UI_PATH.DATE)
  if (!date) {
    return new Date()
  }
  return new Date(date)
}

const getDateAgendaUiSelect = (state) => {
  return getDateSelect(state)
}

export const getDayDateAgendaSelect = (state) => {
  const date = getDateAgendaUiSelect(state)
  return getDayDateStrDateUtil(date)
}

export const getStartDateRangeSelect = (state) => {
  return formatISODateUtil(startOfDayDateUtil(getDateSelect(state)))
}

export const getEndDayDateRangeSelect = (state) => {
  return formatISODateUtil(endOfDayDateUtil(getDateSelect(state)))
}

const DAYS_COUNT_PRIOR_CURRENT_DATE_AGENDA = 5
export const getDatesAgendaUiSelect = createSelector(getDateAgendaUiSelect,
  date => {
    const currentDate = new Date(date)
    return rangeArrayUtil(0, DAYS_COUNT_PRIOR_CURRENT_DATE_AGENDA)
      .reverse()
      .map(dayToSubtract => {
        return subDaysDateUtil(currentDate, dayToSubtract)
      })
  }
)

export default getDateAgendaUiSelect
